import Navbar from "@/components/feature/Navbar";
import Seo from "@/components/feature/Seo";
import StickyCTA from "@/components/feature/StickyCTA";
import { faqJsonLd } from "@/lib/seo";
import { pageMeta } from "@/lib/pageMeta";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import LATourGuide from "./components/LATourGuide";
import ReservationSection from "./components/ReservationSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const jsonLd = [faqJsonLd];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title={pageMeta.home.title}
        description={pageMeta.home.description}
        path={pageMeta.home.path}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <LATourGuide />
        <ReservationSection />
        <FAQSection />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
